import {
  createValidation,
  validatorDateGreaterThen,
  validatorRequired,
} from '../../utils/formValidators';
import { formTsAgreementWithdrawFields } from '../../constants/forms/formTsAgreementWithdraw';
import dayjs from '../../utils/dayjs';

const customValidatorDateGreaterThen = () => (field, form) =>
  form.get(formTsAgreementWithdrawFields.VIOLATION)
    ? validatorDateGreaterThen(dayjs())(field)
    : validatorDateGreaterThen()(field);

export default createValidation([
  {
    name: formTsAgreementWithdrawFields.EFFECTIVE_DATE,
    validators: [
      (field) => validatorRequired()(field),
      customValidatorDateGreaterThen(),
    ],
  },
  {
    name: formTsAgreementWithdrawFields.REASON,
    validators: (field) => validatorRequired()(field),
  },
]);
